import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import asistenciaService from "../../../services/asistenciaService";
import moment from "moment";
import HeaderActa from "../../../components/headerActas";
import utils from '../../../utils/generalFunctions';
import academicService from "../../../services/academicService";
import { toast } from 'react-toastify';
import Loading from "../../../components/Loading";
import JornadaAnioPeriodoNivelCurso from "../../../components/Filters/JornadaAnioPeriodoNivelCurso";
import FooterActa from "../../../components/FooterActa";
import estudiantesService from "../../../services/estudiantesService";
import DataTable from "react-data-table-component";
import useCustomDataTableStyles from "../../../components/estilosDeDataTable";
import evaluativeScaleService from "../../../services/evaluativeScaleService";
import RepoBoletin from "./boletin";
import RepoBoletinDiurna from "./boletin-diurna";
import RepoBoletinDimension from "./boletin-dimension";

const RepoBoletinSemi = () => {
    const filteReference = useRef(null);
    const initData ={
        schoolYearId: "0",
        journeyId:"0",
        periodId:"",
        educationLevelId: "0",
    };
    const [formData, setFormData] = useState(initData);
    const [asistencias, setAsistencias] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [datosBusqueda, setDatosBusqueda] = useState([]);
    const [periodos, setPeriodosList] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [estudiantes, setEstudiantes] = useState([]);    
    const [evaluationScale, setEvaluationScale] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [boletinInfo, setBoletinInfo] = useState(null);
    const [boletinValorativo, setBoletinValorativo] = useState(null);
    const [boletinDimension, setBoletinDimension] = useState(null);
    
    const updateForm = async (data) => {
        if (data.schoolYearId!==formData.schoolYearId){   
          await cargarPeriodos(data.schoolYearId);
        }
        setFormData(prevState => ({
            ...prevState,
            ...data
          }));
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const cargarPeriodos = async (schoolYearId) => {
        try {
            const schoolYear = await academicService.getYearById(schoolYearId);              
            if(schoolYear){
                setPeriodosList(schoolYear.periods)
            }            
        } catch (error) {
             console.error("Error al obtener información de año escolar:", error);
        }
      }

    const generarCosolidadReporteTotal = async () =>{
      setBoletinInfo(null);
        const requiredFields = ['schoolYearId', 'journeyId', 'periodId','educationLevelId','courseId'];
        for (let field of requiredFields) {
            if (!formData[field] || formData[field]==='0') {
                toast.error("Por favor, completa todos los campos obligatorios.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                return;
            }
        }
        setDatosBusqueda([]);
        setShowLoading(true);
        try {
           const copyData = utils.copy(formData);
           copyData.periodName = periodos.find(p=>String(p.academicPeriodId)===String(copyData.periodId))?.periodName??"";
           const years = filteReference.current?.getSchoolYears();
           if(years){
                copyData.year = years.find(p=>String(p.schoolYearId)===String(copyData.schoolYearId))?.year??"";
           }
           const journeys = filteReference.current?.getJourneys();
           if(journeys){
                copyData.journey = journeys.find(p=>String(p.journeyId)===String(copyData.journeyId))?.name??"";
           }

           const courses = filteReference.current?.getCursos();
           if(courses){
                copyData.course = courses.find(p=>String(p.courseId)===copyData.courseId)?.name??"";
           }

           const educationLevels = filteReference?.current?.getEducationLeves();
           if (educationLevels.length > 0) {
                copyData.evaluationTypeId = educationLevels.find((c) => String(c.educationLevelId) === String(copyData.educationLevelId))?.evaluationTypeId;
           }

          const evaluationScaleResult = await evaluativeScaleService.getEvaluativeScale(
                copyData.evaluationTypeId,
                copyData.schoolYearId
          );
          setEvaluationScale(evaluationScaleResult);

           setDatosBusqueda(copyData);
           const date = moment(formData.startDate).format("yyyy-MM-DD");
           const prevData = await estudiantesService.getEstudiantesPorCurso(
            "",
            copyData.journeyId,
            copyData.schoolYearId,
            copyData.educationLevelId,
            copyData.courseId
          ); // Obtenemos los estudiantes de tu sistema
          const data = prevData.filter(s=>s.isActive);
          if(data && data.length>0){
            setEstudiantes(data);
          }else{
            toast.error("No se encontraron estudiantes matriculados.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setEstudiantes([]); 
          }
        } catch (error) {
          console.error("Error al obtener asistencias:", error);
        }
        setShowLoading(false);
    }

    const volverLista =  async () => {
        setBoletinInfo(null);
        setBoletinValorativo(null);
        setBoletinDimension(null);
    };

    const generarBoletin =  async (student) => {
        setShowLoading(true);
        if(String(formData.schoolYearId)==="11" || String(formData.schoolYearId)==="12" ||
           String(formData.schoolYearId)==="18" || String(formData.schoolYearId)==="19" ){
          const data = await estudiantesService.getEstudianteBoletin(
              student.studentId,
              formData.courseId,
              formData.schoolYearId,
              formData.periodId,
              1
            ); // Obtenemos los estudiantes de tu sistema
            console.log(data);
            setBoletinInfo(data);
            setBoletinValorativo(null);
            setBoletinDimension(null);
            setShowLoading(false);
        }else{
          if(Number(formData.educationLevelId)>1){
                const data = await estudiantesService.getEstudianteBoletinValorativo(
                    student.studentId,
                    formData.courseId,
                    formData.schoolYearId,
                    formData.periodId,
                    false
                  ); // Obtenemos los estudiantes de tu sistema
                  console.log(data);
                  setBoletinValorativo(data[0]);
                  setBoletinDimension(null);
                  setBoletinInfo(null);
                  setShowLoading(false);
          }else{
            const data = await estudiantesService.getEstudianteBoletinDimension(
              student.studentId,
              formData.courseId,
              formData.schoolYearId,
              formData.periodId
            ); // Obtenemos los estudiantes de tu sistema
            console.log(data);
            setBoletinValorativo(null);
            setBoletinDimension(data[0]);
            setBoletinInfo(null);
            setShowLoading(false);
          }
        }
    };

    

    const columns = [
        { name: "Número", selector: "consecutive", sortable: true, 
        cell: (row, index) => <span>{index + 1}</span>, },      
        { name: "ID", selector: "identification", sortable:true,grow:"2.5",},
        { name: "Nombre completo", selector: "fullName", sortable:true,grow:"6"}, // Asumiendo que 'nombre' contiene tanto el nombre como el apellido
        {
          name: "Acciones",grow:"3",
          selector: "actions",
          cell: (row) => (
            <div className=" actions-container justify-content-between align-items-center">
                <button
                    onClick={() => generarBoletin(row)}
                    className="btn btn-pinterest"
                    title="Exportar">
                    <i class="fa-regular fa-file-pdf"></i>
                </button>
            </div>
          ),
        },
      ];

    const normalizeString = (str) => {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
    };

    const filteredItems = estudiantes?.filter((item) => {
        if (item) {
          const allData = `${item.fullName} ${item.identification} `;
          const normalizedFilterText = normalizeString(filterText);
          const normalizedItemName = normalizeString(allData);
          return normalizedItemName.includes(normalizedFilterText);
        }
        return item;
      });
    
    const customStyles = useCustomDataTableStyles();


    return (
        <>
          <div className="card p-3 filter-container">
            <h1>Boletin</h1>
            <p>Selecciona los filtros para generar el reporte.</p>
            
                <div className="row">
                    <JornadaAnioPeriodoNivelCurso
                                callback={updateForm}
                                ref={filteReference}
                                loadTutoria={true}
                                loadCoordinators={true}
                                hideAsignatura={true}
                                properties={
                                    {
                                        className:'col-md-2 mb-2',
                                        id:'formReport2',
                                        filtro:false
                                    }
                                }
                            />
                        <div className="col-md-2 mb-1 margin-top-45">
                                <button onClick={generarCosolidadReporteTotal} className="ml-2 btn btn-primary">Buscar</button>
                        </div>
                </div>
          </div>
          {showLoading && <Loading />}

          {!showLoading && estudiantes.length>0 && !boletinInfo && !boletinValorativo && !boletinDimension  && (
            <>
             <div className="card p-3 mt-3">
              <div className="card mb-3 d-flex justify-content-between align-items-center w-50">
                <input
                    type="text"
                    placeholder="Buscar estudiante"
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                    className="form-control "
                />
                </div>
                <DataTable
                title="Lista de estudiantes"
                className="students-datatable shadow-sm rounded"
                columns={columns}
                noDataComponent="No hay información que mostrar, por favor añadela"   
                data={filteredItems}
                pagination
                fixedHeader
                fixedHeaderScrollHeight="450px"
                customStyles={customStyles}
                paginationPerPage={50} // Agrega esta propiedad para controlar las filas por página
                paginationRowsPerPageOptions={[50, 100]}

            />
            </div>
            </>
          )}

            {!showLoading && boletinInfo && (
                  <div>
                  <button className="btn btn-secondary"  onClick={()=>{volverLista()}}><i className="fas fa-arrow-left"></i>Volver a lista</button>
                  <RepoBoletin
                    boletin={boletinInfo}
                />
                </div>
            )}

            {!showLoading && boletinValorativo && (
                  <div>
                  <button className="btn btn-secondary"  onClick={()=>{volverLista()}}><i className="fas fa-arrow-left"></i>Volver a lista</button>
                  <RepoBoletinDiurna
                    boletin={boletinValorativo}
                />
                </div>
            )}

            {!showLoading && boletinDimension && (
                  <div>
                  <button className="btn btn-secondary"  onClick={()=>{volverLista()}}><i className="fas fa-arrow-left"></i>Volver a lista</button>
                  <RepoBoletinDimension
                    boletin={boletinDimension}
                />
                </div>
            )}
        </>
    );
};
  
export default RepoBoletinSemi;